import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';

import { environment } from '../../environments/environment';

// TODO Rewrite with Http Plugin: https://github.com/capacitor-community/http
// This will prevent CORS issues on native apps, and if self hosted, no need for CORS
@Injectable({
  providedIn: 'root'
})
export class ApiService {

  apiUrl: string = environment.apiBaseUrl;

  constructor(private http: HttpClient) { }

  constructParams(params: any): HttpParams {
    let result = new HttpParams();
    Object.keys(params)?.forEach(k => {
      result = result.set(k, params[k]);
    });
    return result;
  }

  get(endpoint: string, params?: any): Observable<any> {
    if (params != null) {
      params = this.constructParams(params);
    }
    return this.http.get(this.apiUrl + endpoint, { params }).pipe(take(1));
  }

  post(endpoint: string, body: any, params?: any): Observable<any> {
    if (params != null) {
      params = this.constructParams(params);
    }
    return this.http.post(this.apiUrl + endpoint, body, { params }).pipe(take(1));
  }

  put(endpoint: string, body: any, params?: any): Observable<any> {
    if (params != null) {
      params = this.constructParams(params);
    }
    return this.http.put(this.apiUrl + endpoint, body, { params }).pipe(take(1));
  }

  delete(endpoint: string, params?: any): Observable<any> {
    if (params != null) {
      params = this.constructParams(params);
    }
    return this.http.delete(this.apiUrl + endpoint, { params }).pipe(take(1));
  }
}
